module.exports = __webpack_public_path__ + "f02e37558cc406b3253fd3eafc93d0b2.png";